import {AsyncPipe} from '@angular/common'
import {Component, inject} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../../../environments/environment'
import {ConfigService} from '../../services/config.service'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  imports: [
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    AsyncPipe,
    MatButton,
    MatMenuItem,
    LogoComponent,
    ToggleButtonComponent
  ],
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  public configService = inject(ConfigService)
  protected readonly environment = environment

}
